import React from 'react';
import CommercialLayout from '../../components/commercial/CommercialLayout';

export default function CommercialLeaderboardPage() {
    return (
        <CommercialLayout title="Classement des Meilleurs Vendeurs 🏆">
            <div className="commercial-page-wrapper" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                textAlign: 'center'
            }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚧</div>
                <h1 style={{
                    fontSize: '2.5rem',
                    background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    marginBottom: '1rem'
                }}>
                    Bientôt Disponible
                </h1>
                <p style={{
                    fontSize: '1.2rem',
                    color: 'var(--commercial-muted)',
                    maxWidth: '600px',
                    lineHeight: '1.6'
                }}>
                    Nous préparons une arène digne des plus grands champions.<br />
                    Le classement mondial des vendeurs sera bientôt ouvert. Préparez-vous à entrer dans la légende !
                </p>

                <div style={{
                    marginTop: '3rem',
                    padding: '2rem',
                    background: 'var(--commercial-panel-2)',
                    borderRadius: '16px',
                    border: '1px dashed var(--commercial-border)'
                }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>En attendant...</div>
                    <div style={{ color: 'var(--commercial-muted)' }}>Continuez à faire grimper votre chiffre d'affaires ! 🚀</div>
                </div>
            </div>
        </CommercialLayout>
    );
}
